import { useState, useEffect, useCallback } from 'react';
import { _registerToastCallback } from './toast';
import './ToastContainer.css';

const ICONS = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };
const AUTO_DISMISS = 3500;

export default function ToastContainer() {
  const [toasts, setToasts] = useState([]);

  const remove = useCallback((id) => {
    setToasts(prev => prev.map(t => t.id === id ? { ...t, leaving: true } : t));
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), 210);
  }, []);

  useEffect(() => {
    _registerToastCallback(({ message, type }) => {
      const id = Date.now() + Math.random();
      setToasts(prev => [...prev, { id, message, type }]);
      setTimeout(() => remove(id), AUTO_DISMISS);
    });
  }, [remove]);

  return (
    <div className="toast-container">
      {toasts.map(t => (
        <div key={t.id} className={`toast toast-${t.type}${t.leaving ? ' toast-leaving' : ''}`}>
          <span className="toast-icon">{ICONS[t.type] || ICONS.info}</span>
          <span className="toast-msg">{t.message}</span>
          <button className="toast-close" onClick={() => remove(t.id)}>×</button>
        </div>
      ))}
    </div>
  );
}
